<template>
    <div v-if="testingEventCandidate">
        <div class="mytooltip-wrapper" style="display: inline-block">
            <a href="javascript:void(0)">
                <span v-if="!isIcon" :class="{'badge--success' : testingStatus==='IN_TESTING', 'badge--accent' : testingStatus==='TESTING_FINISHED','badge--warning' : testingCancelled}" class="badge ml-2">
                    {{ getTranslation(testingStatus) }}
                </span>
                <svg v-else-if="testingCancelled" class="alert__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
                    <circle cx="27" cy="27" r="25" fill="none" stroke="#FFB119" stroke-miterlimit="10" stroke-width="4"></circle>
                    <g>
                        <rect x="25" y="17.15" width="4" height="11.69" rx="1" ry="1" fill="#FFB119"></rect>
                        <rect x="25" y="32.85" width="4" height="4" rx="1" ry="1" fill="#FFB119"></rect>
                    </g>
                </svg>
                <span class="status-icon" :title="getTranslation('CANDIDATE_PASSED')" v-else-if="isIcon && testingEventCandidate.status === 'PASSED'">
                     <svg class="alert__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
                          <circle cx="27" cy="27" r="25" fill="none" stroke="#2FD485" stroke-miterlimit="10" stroke-width="4"></circle>
                          <path d="M39.37,18.87,38,17.45a1,1,0,0,0-1.41,0L22.4,31.6l-4.95-4.95a1,1,0,0,0-1.41,0l-1.41,1.41a1,1,0,0,0,0,1.41l5.66,5.66h0l1.41,1.41a1,1,0,0,0,1.41,0l1.41-1.41h0L39.37,20.28A1,1,0,0,0,39.37,18.87Z" fill="#2FD485"></path>
                     </svg>
                </span>
              <span v-else-if="isIcon && testingStatus === 'IN_TESTING' && !testingEventCandidate.endTime" :title="getTranslation('IN_TESTING')" >
                <svg class="alert__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
                          <circle cx="27" cy="27" r="25" fill="none" stroke="#288BE4" stroke-miterlimit="10" stroke-width="4"></circle>
                          <g>
                            <rect x="25" y="25.15" width="4" height="11.69" rx="1" ry="1" fill="#288BE4"></rect>
                            <rect x="25" y="17.15" width="4" height="4" rx="1" ry="1" fill="#288BE4"></rect>
                          </g>
                        </svg>
              </span>
                <span v-else-if="isIcon && testingEventCandidate.status === 'FAILED'" :title="getTranslation('CANDIDATE_FAILED')">
                    <svg class="alert__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
                      <circle cx="27" cy="27" r="25" fill="none" stroke="#EB2626" stroke-miterlimit="10" stroke-width="4" />
                      <path fill="#EB2626"
                            d="M29.83,27l6.72-6.72a1,1,0,0,0,0-1.41l-1.41-1.41a1,1,0,0,0-1.41,0L27,24.17l-6.72-6.72a1,1,0,0,0-1.41,0l-1.41,1.41a1,1,0,0,0,0,1.41L24.17,27l-6.72,6.72a1,1,0,0,0,0,1.41l1.41,1.41a1,1,0,0,0,1.41,0L27,29.83l6.72,6.72a1,1,0,0,0,1.41,0l1.41-1.41a1,1,0,0,0,0-1.41Z">
                      </path>
                    </svg>
                </span>
            </a>
            <div class="mytooltip  mytooltip--dark  mytooltip--bottom-right" style="right:0">
                <div class="mytooltip__arrow"></div>
                <div class="mytooltip__header  pb-0">
                    <div class="mytooltip__header-inner">
                        <h4 class="mytooltip__title  mytooltip__title--light">{{ getTranslation('testing') }}</h4>
                        <div class="mytooltip__controls" v-if="testingEventCandidate.endTime && hasPermission('api.candidate.profile.detailedResults')">
                            <router-link :to="{ name: 'api.candidate.profile.detailedResults', params: { id:testingEventCandidate.candidateId,appId:testingEventCandidate.appId},query:{resultId:testingEventCandidate.id} }"
                                         class="btn btn--sm btn--link">{{ getTranslation('candiateDetailedResults') }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="mytooltip__body">
                    <table class="table-doc">
                        <tbody>
                            <tr>
                                <th class="table-doc__cell  table-doc__cell--head">
                                    {{ getTranslation('status') }}:
                                </th>
                                <td class="table-doc__cell  table-doc__cell--light">
                                  <span class="badge badge--success" v-if="testingStatus === 'IN_TESTING'" >
                                    {{ getTranslation('IN_TESTING') }}
                                  </span>
                                    <span v-else :class="{'badge--success' : testingEventCandidate.status==='PASSED', 'badge--accent' : testingEventCandidate.status==='FAILED' && testingEventCandidate.endTime,'badge--warning' : testingCancelled}" class="badge">
                                        {{ getTranslation(testingCancelled ? 'TESTING_CANCELLED': 'CANDIDATE_'+testingEventCandidate.status) }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th class="table-doc__cell  table-doc__cell--head">
                                    {{ getTranslation('language') }}:
                                </th>
                                <td class="table-doc__cell  table-doc__cell--light">
                                    {{ $lang.app[testingEventCandidate.lang] }}
                                </td>
                            </tr>
                            <tr>
                                <th class="table-doc__cell  table-doc__cell--head">
                                    {{ getTranslation('startTime') }}:
                                </th>
                                <td class="table-doc__cell  table-doc__cell--light">
                                    {{ momentFormatDate(testingEventCandidate.startTime,'HH:mm') }}
                                </td>
                            </tr>
                            <tr v-if="testingEventCandidate.endTime">
                                <th class="table-doc__cell  table-doc__cell--head">
                                    {{ getTranslation('finishTime') }}:
                                </th>
                                <td class="table-doc__cell  table-doc__cell--light">
                                    {{ momentFormatDate(testingEventCandidate.endTime,'HH:mm') }}
                                </td>
                            </tr>
                            <tr>
                                <th class="table-doc__cell  table-doc__cell--head">
                                    {{ getTranslation('testingDate') }}:
                                </th>
                                <td class="table-doc__cell  table-doc__cell--light">
                                    {{ momentFormatDate(testingEventCandidate.startTime,'DD.MM.YYYY') }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TestingStatusCardComponent",
        props: {
            testingStatus: {
                type: String,
                required: false
            },
            testingEventCandidate: {
                type: Object,
                required: true
            },
            isIcon: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            testingCancelled() {
                return this.testingStatus === 'TESTING_CANCELLED';
            }
        }
    }
</script>

<style scoped>
    .alert__icon {
        max-width: 40px;
    }
</style>
